export const QUALITY_CRITERIA_MODAL_TITLE = 'Критерии качества агентов Циана';

export const QUALITY_CRITERIA_LIST = [
  'Профессионально занимаются недвижимостью больше 5 лет',
  'Хорошая репутация на Циане',
  'Получают отличные отзывы от клиентов',
  'Закрыли много сделок',
  'Своевременно отвечают на звонки и сообщения',
  'Имеют опыт работы со сложными кейсами',
  'Подтвердили свои документы',
];
